import { isDefined } from '@library/guards'
import type { Nullable } from '@library/types'
import { isNumber } from 'common/helpers'

export const convertToNumber = (value: Nullable<string | number>): Nullable<number> => {
  if (isDefined(value) && (isNumber(value) || isNumeric(value))) {
    return Number(value)
  }

  return null
}

const COMPLETE_FLOAT_NUMERIC_REGEX = /^[+-]?\d*(?:[.,]?\d+)$/
const SEMI_COMPLETE_FLOAT_NUMERIC_REGEX = /^[+-]?\d*[.,]?$/
const NOT_COMPLETE_FLOAT_NUMERIC_REGEX = /^[+-.,]$/
const NOT_COMPLETE_FLOAT_WITH_INSIGNIFICANT_ZEROS_REGEX = /^[+-]?0\.0+$/

const NOT_COMPLETE_INTEGER_NUMERIC_REGEX = /^[+-]?$/
const COMPLETE_INTEGER_NUMERIC_REGEX = /^[+-]?\d+$/

/**
 * Проверяет, является ли введенное число валидным действительным числом
 *
 * Не проверяется научная нотация
 */
export function isNumeric(value: string) {
  return COMPLETE_FLOAT_NUMERIC_REGEX.test(value)
}

/**
 * Проверяет, является ли введенное число законченным наполовину действительным числом
 *
 * То есть пытаемся ввести . или , в середину
 */
export function isSemiCompleteFloatNumeric(value: string) {
  return SEMI_COMPLETE_FLOAT_NUMERIC_REGEX.test(value)
}

/**
 * Проверяет, является ли введенная строка началом валидного действительного числа
 *
 * То есть мы вводим +, -, . или , в начало строки
 */
export function isNotCompleteFloatNumeric(value: string) {
  return NOT_COMPLETE_FLOAT_NUMERIC_REGEX.test(value)
}

/**
 * Проверяет, является ли введенная строка числом 0.0...0 (с незначащими знаками после запятой)
 */
export function isNumericWithInsignificantZeros(value: string) {
  return NOT_COMPLETE_FLOAT_WITH_INSIGNIFICANT_ZEROS_REGEX.test(value)
}

/**
 * Проверяет, является ли введенная строка началом валидного целого числа
 *
 * Не проверяется научная нотация
 */
export function isNotCompleteIntegerNumeric(value: string) {
  return NOT_COMPLETE_INTEGER_NUMERIC_REGEX.test(value)
}

/**
 * Проверяет, является ли введенное число началом валидного целого числа
 *
 * Не проверяется научная нотация
 */
export function isIntegerNumeric(value: string) {
  return COMPLETE_INTEGER_NUMERIC_REGEX.test(value)
}
